import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {
    group: {},
    permissions: [],
    roleAllocations: [],
  },
  token: "",
};

const unoUserSlice = createSlice({
  name: "unoUserSlice",
  initialState,
  reducers: {
    saveUserData: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    removeUser: (state) => {
      state.user = {};
      state.token = "";
    },
  },
});

export const { saveUserData, removeUser } = unoUserSlice.actions;
export default unoUserSlice.reducer;
